import { useEffect, useState } from 'react';
import API_URL from '../../apiConfig';

function Partenaire() {
  const [partenaires, setPartenaires] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [editId, setEditId] = useState(null);

  const [formData, setFormData] = useState({
    prenomPart: '',
    nomPart: '',
    mailPart: '',
    numWhatsapp: '',
    profil: '',
    linkimgPart: null
  });

  const fetchAllPartenaires = async (isSilent = false) => {
    try {
      if (!isSilent) setLoading(true);
      const res = await fetch(`${API_URL}/api/partenaires/allpartenaires`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        credentials: "include"
      });
      const data = await res.json();
      if (data.success) {
        setPartenaires(data.partenaires);
      } else {
        setError("Impossible de charger les partenaires");
      }
    } catch (err) {
      setError("Erreur serveur lors de la récupération des partenaires.");
    } finally {
      if (!isSilent) setLoading(false);
    }
  };

  useEffect(() => {
    document.title = "LAMP | Admin - Partenaires";
    fetchAllPartenaires();
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'linkimgPart') {
      setFormData(prev => ({ ...prev, linkimgPart: files[0] }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleEdit = (p) => {
    setEditId(p.idPart);
    setFormData({
      prenomPart: p.prenomPart || '',
      nomPart: p.nomPart || '',
      mailPart: p.mailPart || '',
      numWhatsapp: p.numWhatsapp || '',
      profil: p.profil || '',
      linkimgPart: null
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const cancelEdit = (e) => {
    if(e) e.preventDefault();
    setEditId(null);
    setFormData({ prenomPart: '', nomPart: '', mailPart: '', numWhatsapp: '', profil: '', linkimgPart: null });
    setMessage("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    setMessage("");

    const data = new FormData();
    data.append('prenomPart', formData.prenomPart);
    data.append('nomPart', formData.nomPart);
    data.append('mailPart', formData.mailPart);
    data.append('numWhatsapp', formData.numWhatsapp);
    data.append('profil', formData.profil);
    if (formData.linkimgPart) {
      data.append('linkimgPart', formData.linkimgPart);
    }

    try {
      const url = editId ? `${API_URL}/maj/partenaires/update/${editId}` : `${API_URL}/maj/partenaires/create`;
      const method = editId ? "PUT" : "POST";
      
      const res = await fetch(url, {
        method: method,
        body: data,
        credentials: "include"
      });
      
      const result = await res.json();
      
      if (result.success) {
        // IMPORTANT: On ne change pas tout l'état d'un coup
        setMessage(editId ? "✅ Mise à jour réussie !" : "✅ Nouveau partenaire ajouté !");
        
        // On réinitialise le formulaire
        setEditId(null);
        setFormData({ prenomPart: '', nomPart: '', mailPart: '', numWhatsapp: '', profil: '', linkimgPart: null });
        
        // Rafraichissement forcé
        fetchAllPartenaires(true);
      } else {
        setMessage("❌ Erreur : " + (result.message || "Problème serveur"));
      }
    } catch (err) {
      console.error(err);
      setMessage("❌ Erreur critique de connexion.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Voulez-vous vraiment supprimer ce partenaire ?")) return;
    try {
      const res = await fetch(`${API_URL}/maj/partenaires/delete/${id}`, {
        method: "DELETE",
        credentials: "include"
      });
      const data = await res.json();
      if (data.success) {
        fetchAllPartenaires(true);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-4 px-2">
        <h2 className="fw-bold outfit text-dark mb-0 animate__animated animate__fadeInLeft">🤝 Nos Fidèles Partenaires</h2>
        <span className="badge bg-primary px-3 py-2 rounded-pill shadow-sm animate__animated animate__fadeInRight">
          {partenaires.length} {partenaires.length > 1 ? 'partenaires' : 'partenaire'}
        </span>
      </div>

      <div className="row g-4 overflow-hidden">
        {/* Formulaire dénué de transitions complexes pour éviter removeChild */}
        <div className="col-lg-5">
            <div className="card border-0 shadow-sm p-4 rounded-4 bg-white sticky-top" style={{ top: '20px', zIndex: 50 }}>
                <div className="d-flex justify-content-between align-items-start mb-4 border-bottom pb-3">
                    <h5 className="fw-bold mb-0 text-primary outfit">
                      <i className={`bi ${editId ? 'bi-pencil-square' : 'bi-person-plus-fill'} me-2`}></i> 
                      {editId ? "Modifier Partenaire" : "Nouveau Partenaire"}
                    </h5>
                    {editId && (
                      <button className="btn btn-sm btn-light border rounded-pill py-1 px-3 shadow-none" onClick={cancelEdit}>
                        <i className="bi bi-x me-1"></i> Annuler
                      </button>
                    )}
                </div>
                
                <form onSubmit={handleSubmit} className="row g-3">
                    <div className="col-md-6">
                        <label className="small fw-bold text-muted text-uppercase mb-1">Prénom</label>
                        <input type="text" name="prenomPart" className="form-control bg-light border-0 p-2" value={formData.prenomPart} onChange={handleChange} required />
                    </div>
                    <div className="col-md-6">
                        <label className="small fw-bold text-muted text-uppercase mb-1">Nom</label>
                        <input type="text" name="nomPart" className="form-control bg-light border-0 p-2" value={formData.nomPart} onChange={handleChange} required />
                    </div>
                    <div className="col-12">
                        <label className="small fw-bold text-muted text-uppercase mb-1">Email</label>
                        <input type="email" name="mailPart" className="form-control bg-light border-0 p-2" value={formData.mailPart} onChange={handleChange} required />
                    </div>
                    <div className="col-12">
                        <label className="small fw-bold text-muted text-uppercase mb-1">Numéro Whatsapp</label>
                        <input type="text" name="numWhatsapp" className="form-control bg-light border-0 p-2" placeholder="243..." value={formData.numWhatsapp} onChange={handleChange} required />
                    </div>
                    <div className="col-12">
                        <label className="small fw-bold text-muted text-uppercase mb-1">Profil / Fonction</label>
                        <input type="text" name="profil" className="form-control bg-light border-0 p-2" placeholder="Ex: Donateur" value={formData.profil} onChange={handleChange} />
                    </div>
                    <div className="col-12">
                        <label className="small fw-bold text-muted text-uppercase mb-1">Photo / Logo {editId && "(laisser vide pour garder l'ancienne)"}</label>
                        <input type="file" name="linkimgPart" className="form-control bg-light border-0 p-2 shadow-none" accept="image/*" onChange={handleChange} />
                    </div>
                    <div className="col-12 mt-4 pt-2">
                        <button type="submit" disabled={isSubmitting} className={`btn ${editId ? 'btn-info text-white' : 'btn-primary'} w-100 py-3 fw-bold rounded-4 shadow-none border-0`}>
                            {isSubmitting ? (
                              <><span className="spinner-border spinner-border-sm me-2"></span> TRAITEMENT...</>
                            ) : (editId ? "METTRE À JOUR" : "ENREGISTRER")}
                        </button>
                    </div>
                </form>
                
                {message && (
                  <div className={`mt-4 p-3 small text-center rounded-4 shadow-sm border ${message.includes('✅') ? 'bg-success text-white border-success' : 'bg-danger text-white border-danger'}`}>
                      {message}
                  </div>
                )}
            </div>
        </div>

        {/* Liste des partenaires */}
        <div className="col-lg-7">
            <div className="row g-3">
                {loading && partenaires.length === 0 ? (
                    <div className="col-12 text-center py-5">
                        <div className="spinner-border text-primary"></div>
                    </div>
                ) : null}

                {error && (
                    <div className="col-12 py-3"><div className="alert alert-danger">{error}</div></div>
                )}

                {partenaires.map((p) => (
                    <div key={p.idPart || `temp-${p.mailPart}`} className="col-md-6 col-xl-4 pb-2 animate__animated animate__fadeInUp">
                        <div className={`card border-0 shadow-sm p-3 h-100 transition-all position-relative bg-white rounded-4 ${editId === p.idPart ? 'border border-primary border-2 shadow-lg' : ''}`}>
                            <div className="position-absolute top-0 end-0 m-2 d-flex gap-2" style={{ zIndex: 10 }}>
                                <button 
                                    onClick={() => handleEdit(p)}
                                    className="btn btn-sm btn-white text-primary rounded-circle border shadow-sm p-1 d-flex align-items-center justify-content-center"
                                    style={{ width: '30px', height: '30px' }}
                                    title="Modifier"
                                >
                                    <i className="bi bi-pencil-fill" style={{ fontSize: '0.75rem' }}></i>
                                </button>
                                <button 
                                    onClick={() => handleDelete(p.idPart)}
                                    className="btn btn-sm btn-white text-danger rounded-circle border shadow-sm p-1 d-flex align-items-center justify-content-center"
                                    style={{ width: '30px', height: '30px' }}
                                    title="Supprimer"
                                >
                                    <i className="bi bi-trash-fill" style={{ fontSize: '0.75rem' }}></i>
                                </button>
                            </div>
                            <div className="text-center mb-3 pt-3">
                                <img 
                                    src={p.linkimgPart || `https://ui-avatars.com/api/?name=${p.prenomPart}+${p.nomPart}&background=random&color=fff&size=80`} 
                                    alt="profil" 
                                    className="rounded-circle border border-4 border-light shadow-sm"
                                    width="70"
                                    height="70"
                                    style={{ objectFit: 'cover' }}
                                />
                            </div>
                            <div className="text-center">
                                <h6 className="fw-bold text-dark mb-0 outfit text-truncate px-1" style={{ fontSize: '1rem' }}>{p.prenomPart} {p.nomPart}</h6>
                                <p className="text-muted extra-small mb-1 text-uppercase fw-bold opacity-50 tracking-widest">{p.profil || "Fidèle Partenaire"}</p>
                                <p className="text-muted extra-small mb-3 text-truncate-2 px-1" style={{ fontSize: '0.7rem' }}>{p.mailPart}</p>
                                <div className="px-1">
                                    <a 
                                        href={`https://wa.me/${p.numWhatsapp}`} 
                                        target="_blank" 
                                        rel="noopener noreferrer" 
                                        className="btn btn-sm btn-success rounded-pill w-100 d-flex align-items-center justify-content-center gap-2 fw-bold extra-small py-2 border-0 shadow-sm text-decoration-none"
                                    >
                                        <i className="bi bi-whatsapp"></i> {p.numWhatsapp}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
                
                {!loading && partenaires.length === 0 && !error && (
                    <div className="col-12 text-center py-5 bg-white rounded-5 shadow-sm border border-dashed border-2">
                        <i className="bi bi-people fs-1 text-muted opacity-25"></i>
                        <p className="text-muted mt-2 fw-medium">Aucun partenaire enregistré.</p>
                    </div>
                )}
            </div>
        </div>
      </div>
      <style>{`
        .extra-small { font-size: 0.72rem; }
        .tracking-widest { letter-spacing: 0.1em; }
        .transition-all { transition: all 0.3s ease; }
        .hover-shadow:hover { box-shadow: 0 15px 30px rgba(0,0,0,0.1) !important; transform: translateY(-5px); }
        .text-truncate-2 { display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
        .btn-white { background: white; border: 1px solid #eee; }
      `}</style>
    </div>
  );
}

export default Partenaire;